module.exports = __webpack_public_path__ + "static/media/espiga_sanvicente.5ed128db.png";